// Right-column container. Switches on question.type and delegates to
// the appropriate panel component.

import MapIdentifyPanel from './MapIdentifyPanel';
import MapLocatePanel from './MapLocatePanel';
import MapMcqPanel from './MapMcqPanel';
import MapShortAnswerPanel from './MapShortAnswerPanel';

export default function QuestionPanel({
  question,
  entityLabels,
  state,
  isLast,
  onAction,
}) {
  if (question.type === 'map_identify') {
    return (
      <MapIdentifyPanel
        question={question}
        entityLabels={entityLabels}
        state={state}
        onSubmit={() => onAction({ type: 'submit' })}
        onNext={() => onAction({ type: 'next' })}
        isLast={isLast}
      />
    );
  }

  if (question.type === 'map_locate') {
    return (
      <MapLocatePanel
        question={question}
        entityLabels={entityLabels}
        state={state}
        onSubmit={() => onAction({ type: 'submit' })}
        onNext={() => onAction({ type: 'next' })}
        isLast={isLast}
      />
    );
  }

  if (question.type === 'map_mcq') {
    return (
      <MapMcqPanel
        question={question}
        state={state}
        onSelectOption={(id) => onAction({ type: 'select_option', id })}
        onSubmit={() => onAction({ type: 'submit' })}
        onNext={() => onAction({ type: 'next' })}
        isLast={isLast}
      />
    );
  }

  if (question.type === 'map_short_answer') {
    return (
      <MapShortAnswerPanel
        question={question}
        state={state}
        onChangeText={(text) => onAction({ type: 'change_text', text })}
        onSubmit={() => onAction({ type: 'submit' })}
        onSelfAssess={(choice) => onAction({ type: 'self_assess', choice })}
        onNext={() => onAction({ type: 'next' })}
        isLast={isLast}
      />
    );
  }

  return (
    <div className="text-sm text-red-600">
      Unknown question type: <code>{question.type}</code>
    </div>
  );
}
